import { useMemo } from "react";
import { UserTypes } from "shared";

import { useGetSelectedOrganisation } from "./useGetSelectedOrganisation";

export function useCurrentOrgUsers(noEmail?: boolean, allowedUserTypes?: UserTypes[]) {
  const currentOrg = useGetSelectedOrganisation();

  const memorised = useMemo(() => {
    if (!currentOrg || !currentOrg.users) {
      return [];
    }

    const users = allowedUserTypes?.length ?
      currentOrg.users.filter(user => allowedUserTypes.includes(user.type)) :
      currentOrg.users;

    return users.map(user => {
      const label = noEmail ?
        `${user.firstName || ``} ${user.lastName || ``}` :
        `${user.firstName || ``} ${user.lastName || ``} (${user.email})`;

      return {
        label: label.trim(),
        value: user.id,
      };
    });
  }, [allowedUserTypes, currentOrg, noEmail]);

  return memorised;
}
